export const SPACES = {
  xxxxl: '1.5rem',
  xxxl: '1.375rem',
  xxl: '1.25rem',
  xl: '1.125rem',
  l: '1rem', // 16px by the default
  m: '0.875rem',
  s: '0.75rem',
  xs: '0.625rem',
  xxs: '0.5rem'
};
